import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  campaigns: {}, 
  loading: false,
  error: null,
  pagination: {},
  selectedCampaign:null
};

/* ================== THUNKS ================== */

export const fetchNotificationCampaigns = createAsyncThunk(
  'notification-campaigns/fetch',
  async ({ fetchType = "table", page = 1, limit = 10, search = '' }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/api/admin/notification-campaigns', {
        params: { fetchType, page, limit, search }
      });
      return {
          data: response.data?.data?.records || [],
          pagination: response.data?.data?.pagination || {},
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const createNotificationCampaign = createAsyncThunk(
  'notification-campaigns/create',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/admin/notification-campaigns', 
        payload
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const fetchNotificationCampaignById = createAsyncThunk(
  'notification-campaigns/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/admin/notification-campaigns/${id}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const updateNotificationCampaign = createAsyncThunk(
  'notification-campaigns/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/api/admin/notification-campaigns/${id}`, formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const deleteNotificationCampaign = createAsyncThunk(
  'notification-campaigns/delete',
  async ({ id }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/api/admin/notification-campaigns/${id}`);
      return { id };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const changeStatusCampaign = createAsyncThunk(
  'notification-campaigns/change-status',
  async ({id, status}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`/api/admin/notification-campaigns/${id}/change-status`,{status});
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);




/* ================== SLICE ================== */

const notificationCampaignSlice = createSlice({
  name: 'notification-campaigns',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* FETCH */
      .addCase(fetchNotificationCampaigns.pending, (state) => {
          state.loading = true;
      })
      .addCase(fetchNotificationCampaigns.fulfilled, (state, action) => {
          const { data, pagination } = action.payload;
          state.loading = false;
          state.pagination = pagination;
          state.campaigns = data;
      })
      .addCase(fetchNotificationCampaigns.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
      })
      .addCase(fetchNotificationCampaignById.fulfilled, (state, action) => {
          state.loading = false;
          state.selectedCampaign = action.payload;
      })
      .addCase(fetchNotificationCampaignById.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
      })
      /* Create */
      .addCase(createNotificationCampaign.fulfilled, (state, action) => {        
          console.log(state,'state');
      })
      /* UPDATE */
      .addCase(updateNotificationCampaign.fulfilled, (state, action) => {        
          console.log(state,'state');
      })
      .addCase(updateNotificationCampaign.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
      })
      .addCase(changeStatusCampaign.fulfilled, (state, action) => {
        state.loading = false;
        const updated = action.payload?.data;
        if (updated) {
            state.campaigns = state.campaigns.map((c) =>
                c.id === updated.id ? updated : c
            );
            state.selectedCampaign = updated;
        }
      })           
      /* DELETE */
      .addCase(deleteNotificationCampaign.fulfilled, (state, action) => {
        state.campaigns = state.campaigns.filter((p) => p._id !== action.payload);
      });
  }
});

export default notificationCampaignSlice.reducer;